import { gql } from "@apollo/client";

export const GET_BLOGS = gql`
  query Blogs {
    blogs {
      id
      slug
      date
      title

      subtitle
      introduction
      content
      coverImage
      club {
        title
        slug
        icon
      }
    }
  }
`;

export const GET_BLOG_BY_ARTICLE = gql`
  query BlogArticle($articleSlug: String!) {
    blog(slug: $articleSlug) {
      slug
      date
      title

      subtitle
      content
      coverImage
      ads
      bannerImage
      club {
        title
        icon
      }
    }
  }
`;
